'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002etime$002e$002dDate$002dTime$002dException from "./java.time.-Date-Time-Exception.js";
var $p;
function $ct_Ljava_time_format_DateTimeParseException__T__jl_CharSequence__I__jl_Throwable__($thiz, message, parsedData, errorIndex, cause) {
  $j_java$002elang$002e$002dObject.$ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, message, cause, true, true);
  $j_java$002elang$002e$002dObject.$dp_toString__T(parsedData);
  return $thiz;
}
export { $ct_Ljava_time_format_DateTimeParseException__T__jl_CharSequence__I__jl_Throwable__ as $ct_Ljava_time_format_DateTimeParseException__T__jl_CharSequence__I__jl_Throwable__ };
function $ct_Ljava_time_format_DateTimeParseException__T__jl_CharSequence__I__($thiz, message, parsedData, errorIndex) {
  $ct_Ljava_time_format_DateTimeParseException__T__jl_CharSequence__I__jl_Throwable__($thiz, message, parsedData, errorIndex, null);
  return $thiz;
}
export { $ct_Ljava_time_format_DateTimeParseException__T__jl_CharSequence__I__ as $ct_Ljava_time_format_DateTimeParseException__T__jl_CharSequence__I__ };
class $c_Ljava_time_format_DateTimeParseException extends $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException {
}
export { $c_Ljava_time_format_DateTimeParseException as $c_Ljava_time_format_DateTimeParseException };
function $isArrayOf_Ljava_time_format_DateTimeParseException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dH)));
}
export { $isArrayOf_Ljava_time_format_DateTimeParseException as $isArrayOf_Ljava_time_format_DateTimeParseException };
var $d_Ljava_time_format_DateTimeParseException = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_format_DateTimeParseException, "java.time.format.DateTimeParseException", ({
  dH: 1,
  bP: 1,
  R: 1,
  Q: 1,
  H: 1,
  a: 1
}));
export { $d_Ljava_time_format_DateTimeParseException as $d_Ljava_time_format_DateTimeParseException };
